<template>
  <div class="product-box flex">
    <!-- 左边 -->
    <div class="left-box">
      <div class="hea-box">
        产品列表
        <div class="btn-box">
          <el-tooltip class="item" effect="dark" content="我的设备" placement="bottom-start">
            <div class="item">
              <img v-show="mySbType == 0 || mySbType == 2" src="@/assets/image/product/wode.png" alt=""
                @click="mySbTypeClick(1)" />
              <img v-show="mySbType == 1" src="@/assets/image/product/wodexuanzhong.png" alt=""
                @click="mySbTypeClick(0)" />
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="他人共享" placement="bottom-end">
            <div class="item">
              <img v-show="mySbType == 0 || mySbType == 1" src="@/assets/image/product/taren.png" alt=""
                @click="mySbTypeClick(2)" />
              <img v-show="mySbType == 2" src="@/assets/image/product/gongxiang.png" alt="" @click="mySbTypeClick(0)" />
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="trees-box" v-if="treeData.length">
        <el-tree ref="trees" :data="treeData" :props="defaultProps" highlight-current
          :default-expanded-keys="[morenzankai]" node-key="id" @node-click="handleNodeClick">
          <template #default="{ node, data }">
            <span class="custom-tree-node">
              <span v-if="data.children && data.children.length">{{ node.label }}（<span class="on-color">{{
                data.online
              }}</span>/{{ data.allNum }}）</span>
              <span v-else :class="{
                'tree-choose-active': playIdObj.id == data.id,
              }"><img class="tree-icon" v-if="data.online" src="../../assets/image/product/icon-online.png"
                  alt="" /><img class="tree-icon" v-else src="../../assets/image/product/icon-offlInne.png" alt="" />{{
                node.label }}
                <img class="tree-icon-soure" v-show="data.source == 1" src="@/assets/image/product/tarengongxing.png"
                  alt="" /></span>
            </span>
          </template>
        </el-tree>
      </div>
      <div class="table-empty flex flex_col flex_ju_c flex_a_c trees-box" v-else>
        <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
        <div class="table-emptyword">暂无数据</div>
      </div>
    </div>
    <!-- 右边 -->
    <!-- 控制类设备 -->
    <template v-if="playIdObjProductType == 6 || playIdObjProductType == 1">
      <div class="center-box">
        <PlayVideo :jkList="jkList" :playIdObj="playIdObj"></PlayVideo>
        <Control ref="Control" :sbAllList="sbAllList" :kgsbList="kgsbList" :xcsbLsist="xcsbLsist"
          :safePassword="safePassword" :playIdObj="playIdObj" :loading="loading" :cgqList="cgqList"
          :playIdObjProductType="playIdObjProductType"></Control>
      </div>
      <div class="right-box">
        <Sensing ref="Sensing" :cgqList="cgqList" :playIdObj="playIdObj"></Sensing>
      </div>
    </template>
    <!-- 采集类设备 -->
    <!-- 气象 -->
    <template v-else-if="playIdObjProductType == 2 || playIdObjProductType == '2-6'">
      <div class="right-box-qx">
        <Qixiang ref="Qixiang" :playIdObj="playIdObj"></Qixiang>
      </div>
    </template>
    <!-- 墒情 -->
    <template v-else-if="playIdObjProductType == 3 || playIdObjProductType == '3-6'">
      <!-- <div class="right-box-no">
        <div class="table-empty flex flex_col flex_ju_c flex_a_c trees-box">
          <img class="table-noimg" src="@/assets/image/product/zwsj2.png" alt="" />
          <div class="table-emptyword">敬请期待</div>
        </div>
      </div> -->
      <div class="right-box-qx">
        <Soilview ref="Soilview" :playIdObj="playIdObj"></Soilview>
      </div>
    </template>
    <template v-else>
      <div class="right-box-no">
        <div class="table-empty flex flex_col flex_ju_c flex_a_c trees-box">
          <img class="table-noimg" src="@/assets/image/product/zwsj2.png" alt="" />
          <div class="table-emptyword">敬请期待</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/*
 * @param: deviceBizStatus
 * @description: 设备初始化状态-- 树形区域与设备在离线socket监听判断使用
 * 0 默认状态| init 初始化中 | notInit 初始化失败 | updating 固件更新中 | notUpdate 固件更新失败 | normal 正常
 *
 * 左侧设备状态对应右侧不同内容
 * normal| 设备在线--正常显示；设备离线--页面置灰不可操作
 * init | 页面整体替换初始化相似
 * notInit | 设备在线 -- 初始化失败，点击重试；设备离线 -- 离线中，初始化失败
 * updating | 固件升级中
 * notUpdate | 固件升级失败
 */
import PlayVideo from "./view/video.vue";
import Control from "./view/control.vue";
import Sensing from "./view/Sensing.vue";
import Qixiang from "./view/qixiang.vue";
import Soilview from "./view/soilview.vue" 
import { mapState } from "vuex";
export default {
  components: { PlayVideo, Control, Sensing, Qixiang, Soilview },
  data() {
    return {
      productType: "1,2,6",
      playIdObjProductType: "",
      // 控制我的区域里设备类型的筛选
      mySbType: 0, //0全部，1我的2他人的
      allTree: [],
      //树形组件数据
      treeData: [],
      // 控制默认展开
      morenzankai: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 存放树形组件的选中
      playIdObj: {},
      routerQuery: null,
      // 是否初始化
      initialization: false,
      // 初始化还是固件升级
      cshAndsj: 1, //0初始化1固件升级
      // 初始化的几种状态
      cshState: 0, //0正在1成功2失败3设备离线
      // 固件升级状态
      sjState: 1, //0正在1失败
      versionNew: "", //固件版本
      jkList: [],
      sbAllList: {}, // 设备总数据
      // 开关设备列表
      kgsbList: [
        // {
        //   state: true,
        //   name: "电磁阀",
        // },
      ],
      // 行程设备列表
      xcsbLsist: [
        // {
        //   name: "卷被机",
        //   state: 0, //0上升1下降
        //   num: "20",
        // },
        // {
        //   name: "卷被机",
        //   state: 0, //0上升1下降
        //   num: "20",
        // },
        // {
        //   name: "卷被机",
        //   state: 1, //0上升1下降
        //   num: "20",
        // },
      ],
      // 是否设置了安全密码
      safePassword: false,
      loading: false,
      // 存储订阅设备推送消息的设备列表
      wsMassageByDeviceList: [],
      // 传感器列表
      cgqList: [],
    };
  },
  created() {
    let router = this.$router.currentRoute.query;
    if (router) {
      this.routerQuery = router.deviceNum;
    } else {
      this.routerQuery = null;
    }
    // this.userDeviceList();
    this.getDeviceList();
    this.querySafePassword();
  },
  mounted() {
    this.$bus.$on("gengxinVideo", this.getVideoList); //刷新监控列表
    console.log("执行");
    this.$bus.$on("xiugaiNameHuiD", this.updateDeviceSub); //修改名称请求回显
  },
  destroyed() {
    this.$bus.$off("gengxinVideo");
    this.$bus.$off("xiugaiNameHuiD");
  },
  computed: {
    //执行设备实时状态
    ...mapState(["deviceMessaageOne", "SocketOpen"]),
  },
  watch: {
    // 左边区域列表
    wsMassageByDeviceList: {
      handler(newVal, oldVal) {
        console.log(newVal);
        if (newVal && newVal.length) {
          setTimeout(() => {
            this.deviceCacheAction(newVal, true);
          }, 1000);
        }
        if (oldVal && oldVal.length) {
          this.deviceCacheAction(oldVal, false);
        }
      },
      deep: true,
      immediate: true,
    },
    // 设备状态改变-只收到了设备编号推送
    deviceMessaageOne: {
      handler(newVal, oldVal) {
        if (!newVal.data) {
          return;
        }
        if (newVal.data != this.playIdObj.deviceNum) {
          return;
        }
        this.updateDeviceSub(this.playIdObj.id);
      },
      deep: true,
      immediate: true,
    },
    // webscoket连接
    SocketOpen: {
      handler(newVal, oldVal) {
        this.deviceCacheAction(this.wsMassageByDeviceList, true);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 更新设备订阅列表
    deviceCacheAction(deviceList, leftPageFlag) {
      if (!deviceList || !deviceList.length) {
        return;
      }

      let ids = [];
      deviceList.forEach((item) => {
        ids.push(item.deviceNum);
      });
      // 去重
      const uniqueArr = [...new Set(ids)];

      let groupsArr = uniqueArr.map((item) => {
        return "GROUPS_DEVICE_ITEM_" + item;
      });
      let groupsArr2 = uniqueArr.map((item) => {
        return "GROUPS_DEVICE_ONLINE_STATUS_" + item;
      });
      let wsParams = {
        srvFeature: leftPageFlag ? "1" : "2",
        srvVer: 1,
        srvTs: new Date().getTime(),
        msgId: Math.floor(Math.random() * 100),
        groups: [...groupsArr, ...groupsArr2],
      };
      this.$webSocketUtil.send(JSON.stringify(wsParams));
    },
    // 我的区域设备类型切换
    mySbTypeClick(index) {
      this.mySbType = index;
    },
    /**
     * 获取数据
     * **/
    // 我的区域树状结构
    userDeviceList() {
      this.$http
        .getAction(this.$api.userDeviceList + "?type=" + this.productType)
        .then((res) => {
          if (res.data) {
            let arr = [];
            let allTree = [];
            let wsMassageByDeviceList = [];
            res.data.forEach((item, index) => {
              if (item.list.length) {
                let obj = {};
                obj.label = item.areaName;
                obj.id = index + "-" + index;
                obj.online = item.onlineNum;
                obj.allNum = item.totalNum;
                obj.children = [];
                item.list.forEach((item2, index2) => {
                  obj.children.push({
                    deviceNum: item2.deviceNum,
                    label: item2.deviceName,
                    id: item2.deviceId,
                    online: item2.deviceStatus == "offline" ? false : true,
                    source: 0, //0自己1共享
                    areaName: item.areaName,
                    deviceId: index + "-" + index,
                    deviceBizStatus: item2.deviceBizStatus,
                    productPic: item2.productPic,
                  });
                  allTree.push({
                    deviceNum: item2.deviceNum,
                    label: item2.deviceName,
                    id: item2.deviceId,
                    online: item2.deviceStatus == "offline" ? false : true,
                    source: 0, //0自己1共享
                    areaName: item.areaName,
                    deviceId: index + "-" + index,
                    deviceBizStatus: item2.deviceBizStatus,
                    index: index,
                  });
                  wsMassageByDeviceList.push(item2);
                });
                arr.push(obj);
              }
            });
            this.wsMassageByDeviceList = wsMassageByDeviceList;
            this.allTree = allTree;
            if (arr.length) {
              this.treeData = arr;
              // console.log(this.treeData);
              if (this.routerQuery) {
                this.treeData.forEach((item, index) => {
                  item.children.forEach((item2, index2) => {
                    if (item2.deviceNum == this.routerQuery) {
                      this.playIdObj = arr[index].children[index2];
                      this.morenzankai = this.treeData[index].id;
                    }
                  });
                });
              } else {
                this.playIdObj = arr[0].children[0];
                this.morenzankai = this.treeData[0].id;
              }
              this.makeDevideStatus();
            } else {
              this.playIdObj = {};
              this.treeData = [];
            }
            // console.log(this.allTree);
          } else {
            this.treeData = [];
            this.allTree = [];
          }
        });
    },
    // 获取左侧产品列表
    getDeviceList() {
      let params = {
        type: this.mySbType,
        deviceType: "",
      };
      if (this.mySbType == 0) {
        params.type = "1";
      }
      this.$http
        .getAction(this.$api.productNameModelList, params)
        .then((res) => {
          if (res.data) {
            let result = this.$route.path
              .split("/")
              .map((item) => item.trim())
              .filter((item) => item !== "");

            let productNameCode = result[1];
            let arr = [];
            let allTree = [];
            let wsMassageByDeviceList = [];
            let dataList = res.data.filter((item, index) => {
              return item.productNameCode == productNameCode;
            });
            let datas = null;
            if (dataList.length) {
              datas = dataList[0].productNameList;
            }
            datas.forEach((item, index) => {
              if (item.deviceList.length) {
                let obj = {};
                obj.label = item.productModelName;
                obj.id = item.productModelId;
                obj.online = item.onlineNum;
                obj.allNum = item.totalDeviceQuantity;
                obj.children = [];
                item.deviceList.forEach((item2, index2) => {
                  obj.children.push({
                    deviceNum: item2.deviceNum,
                    label: item2.deviceName,
                    id: item2.deviceId,
                    online: item2.onlineState == "offline" ? false : true,
                    source: 0, //0自己1共享
                    areaName: item.areaName,
                    deviceId: item2.deviceId,
                    productType: item2.productType,
                    productPic: item2.productPic,
                    // deviceBizStatus: item2.deviceBizStatus,
                  });
                  allTree.push({
                    deviceNum: item2.deviceNum,
                    label: item2.deviceName,
                    id: item2.deviceId,
                    online: item2.onlineState == "offline" ? false : true,
                    source: 0, //0自己1共享
                    areaName: item.areaName,
                    deviceId: item2.deviceId,
                    productType: item2.productType,
                    productPic: item2.productPic,
                    // deviceBizStatus: item2.deviceBizStatus,
                    index: index,
                  });
                  wsMassageByDeviceList.push(item2);
                });
                arr.push(obj);
              }
            });
            this.wsMassageByDeviceList = wsMassageByDeviceList;
            this.allTree = allTree;
            if (arr.length) {
              this.treeData = arr;
              // console.log(this.treeData);
              if (this.routerQuery) {
                this.treeData.forEach((item, index) => {
                  item.children.forEach((item2, index2) => {
                    if (item2.deviceNum == this.routerQuery) {
                      this.playIdObj = arr[index].children[index2];
                      this.morenzankai = this.treeData[index].id;
                    }
                  });
                });
              } else {
                this.playIdObj = arr[0].children[0];
                this.morenzankai = this.treeData[0].id;
              }
              this.playIdObjProductType = this.playIdObj.productType;
              this.makeDevideStatus();
            } else {
              this.playIdObj = {};
              this.treeData = [];
            }
          }
        });
    },
    // 树形组件点击事件
    handleNodeClick(data) {
      // console.log(data);
      // 说明点击的是第一层，拦截点击事件
      if (data.children && data.children.length) return;
      // 此列表单选
      this.playIdObj = data;
      this.playIdObjProductType = this.playIdObj.productType;
      this.makeDevideStatus();
      // this.getVideoList()
      // this.deviceSub()
      // this.getcgqList()
    },
    // 判断设备状态显示
    makeDevideStatus() {
      this.initialization = false;
      if (
        this.playIdObjProductType == "1" ||
        this.playIdObjProductType == "6"
      ) {
        this.$nextTick(() => {
          this.getVideoList();
          this.deviceSub();
          this.getcgqList();
        });
      } else if (
        this.playIdObjProductType == "2" ||
        this.playIdObjProductType == "2-6"
      ) {
        this.$nextTick(() => {
          this.$refs.Qixiang.init();
        });
      } else if (
        this.playIdObjProductType == "3" ||
        this.playIdObjProductType == "3-6"
      ) {
        this.$nextTick(() => {
          this.$refs.Soilview.init();
        });
      }
    },
    // 固件取消升级点击
    firmwarecancelupgrade() {
      let deviceCompNum = "YF" + this.playIdObj.deviceNum + "6"; //喷码号其实就是YF+设备编号+6或者1 , 如果是智能终端的话最后一位是6, 如果是控制箱最后一位是1
      let deviceNum = this.playIdObj.deviceNum;
      this.$http
        .postAction(
          this.$api.CancelUpgrade +
          "?deviceCompNum=" +
          deviceCompNum +
          "&deviceNum=" +
          deviceNum
        )
        .then((res) => {
          if (res.code == 200) {
            this.$refs.myMsg.msgShow("取消成功", 1.5);
            this.makeDevideStatus();
          } else {
            this.$refs.myMsg.msgShow(res.msg, 1.5);
          }
        });
    },
    // 固件重新升级
    firmwareagainupgrade() {
      // 获取固件版本信息
      this.$http
        .getAction(
          this.$api.getDeviceVersion + "?deviceId=" + this.playIdObj.id
        )
        .then((res) => {
          if (res.data.mandatory) {
            let programIdNew = res.data.programIdNew;
            let deviceId = this.playIdObj.id;
            this.$http
              .postAction(
                this.$api.equipmentUpgrade +
                "?deviceId=" +
                deviceId +
                "&programId=" +
                programIdNew
              )
              .then((res2) => {
                if (res2.code == "200") {
                  this.makeDevideStatus();
                } else {
                  this.$refs.myMsg.msgShow(res2.msg, 1.5);
                }
              });
          } else {
            this.makeDevideStatus();
          }
        });
    },
    // 用户设备所关联摄像头
    getVideoList() {
      this.$http
        .getAction(this.$api.deviceCamera + "?deviceId=" + this.playIdObj.id)
        .then((res) => {
          if (res.data && res.data.length) {
            this.isShowVideo = true;
            this.jkList = res.data;
            this.jkAct = this.jkList[0].cameraUrl;
            if (this.jkAct != "") {
              this.isVideoEmpty = false;
              this.$nextTick(() => {
                this.$refs.hlsVideoPlayer.handelVideoUrl(this.jkAct);
              });
            } else {
              this.isVideoEmpty = true;
            }
          } else {
            this.isShowVideo = false;
            this.jkList = [];
            this.jkAct = "";
          }
        });
    },
    // 获取控制设备信息
    deviceSub() {
      this.loading = true;
      this.$http
        .postAction(
          this.$api.deviceSub +
          "?deviceId=" +
          this.playIdObj.id +
          "&subDeviceType=2"
        )
        .then((res) => {
          this.sbAllList = res.data || {};
          if (res.data && res.data.subsetList.length) {
            if (this.playIdObj.id != res.data.deviceId) {
              return;
            }
            this.loading = false;
            // console.log(res.data.subsetList);
            res.data.subsetList.forEach((item) => {
              item.deviceNum = res.data.deviceNum;
            });
            this.kgsbList = res.data.subsetList.filter((item) => {
              if (item.subDeviceType == "2-1") {
                return item;
              }
            });
            this.xcsbLsist = res.data.subsetList.filter((item) => {
              if (item.subDeviceType == "2-2") {
                return item;
              }
            });
          } else {
            this.loading = false;
            this.kgsbList = [];
            this.xcsbLsist = [];
          }
        });
    },
    // 更新控制设备状态
    updateDeviceSub() {
      this.$http
        .postAction(
          this.$api.deviceSub +
          "?deviceId=" +
          this.playIdObj.id +
          "&subDeviceType=2"
        )
        .then((res) => {
          this.sbAllList = res.data || {};
          if (res.data && res.data.subsetList.length) {
            // console.log(res.data.subsetList);
            res.data.subsetList.forEach((item) => {
              item.deviceNum = res.data.deviceNum;
            });
            this.kgsbList = res.data.subsetList.filter((item) => {
              if (item.subDeviceType == "2-1") {
                return item;
              }
            });
            this.xcsbLsist = res.data.subsetList.filter((item) => {
              if (item.subDeviceType == "2-2") {
                return item;
              }
            });
            // 判断开关设备的设置弹层是否打开
            if (this.$refs.Control.$refs.kgSetUp.drawer) {
              this.kgsbList.forEach((item) => {
                if (
                  item.subDeviceNum ==
                  this.$refs.Control.$refs.kgSetUp.infos.subDeviceNums[0]
                ) {
                  let subDeviceNums = [];
                  subDeviceNums.push(item.subDeviceNum);
                  let params = {
                    subDeviceName: item.subDeviceName,
                    subDeviceNums: subDeviceNums,
                    deviceNum: this.sbAllList.deviceNum,
                    commandsItemList: item.commandsItemList,
                    deviceName: this.sbAllList.deviceName,
                    dataItemValue: this.retrunTxt(item.itemList, "status")
                      .dataItemValue,
                    deviceId: this.playIdObj.id,
                  };
                  this.$refs.Control.$refs.kgSetUp.infos = params;
                }
              });
            }
            // 判断行程设备弹层是否打开
            if (this.$refs.Control.$refs.XcSetUp.drawer) {
              this.xcsbLsist.forEach((item) => {
                if (
                  item.subDeviceNum ==
                  this.$refs.Control.$refs.XcSetUp.equipmentInfo.subDeviceNum
                ) {
                  this.$refs.Control.$refs.XcSetUp.equipmentInfo = item;
                  this.$nextTick(() => {
                    this.$refs.Control.$refs.XcSetUp.deviceStatus();
                    this.$refs.Control.$refs.XcSetUp.yuanhuanValue();
                  });
                  // // 判断是否打开了正向总时长设置界面
                  // if (
                  //     this.$refs.XcSetUp.insideSwitch.zxzsc &&
                  //     this.$refs.XcSetUp.getzxzsctype == "1"
                  // ) {
                  //     this.$refs.XcSetUp.zxzscStatusSz();
                  // }
                  // // 判断是否打开了反向总时长
                  // if (
                  //     this.$refs.XcSetUp.insideSwitch.fxzsc &&
                  //     this.$refs.XcSetUp.getfxzsctype == "1"
                  // ) {
                  //     this.$refs.XcSetUp.fxzscStatusSz();
                  // }
                }
              });
            }
            this.$forceUpdate();
          } else {
            this.kgsbList = [];
            this.xcsbLsist = [];
          }
        });
    },
    // 获取传感器设备
    getcgqList() {
      this.$http
        .postAction(
          this.$api.deviceSub +
          "?deviceId=" +
          this.playIdObj.id +
          "&subDeviceType=1"
        )
        .then((res) => {
          if (res.data && res.data.subsetList.length) {
            this.cgqList = res.data.subsetList;
          } else {
            this.cgqList = [];
          }
          this.$nextTick(() => {
            this.$refs.Sensing.init();
          });
        });
    },
    // 返回状态
    retrunTxt(arr, key) {
      let row = arr.filter((item) => {
        return item.dataItemCode == key;
      });
      if (row.length) {
        return row[0];
      }
      return {};
    },
    // 是否设置了安全密码
    querySafePassword() {
      this.$http.getAction(this.$api.querySafePassword).then((res) => {
        this.safePassword = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/trees.scss";
</style>
<style lang="scss" scoped>
.product-box {
  height: 100%;
  min-height: 610px;

  .hea-box {
    height: 0.8rem;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    padding: 0.3rem;
    font-weight: bold;
    color: #454545;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .btn-box {
      display: flex;

      .item {
        margin-left: 0.2rem;
      }

      img {
        cursor: pointer;
      }
    }
  }

  .left-box {
    width: 22.3%;
    position: relative;
    margin-right: 0.25rem;
    height: 100%;
    background: #ffffff;
    border-radius: 0.125rem;

    .trees-box {
      height: 89%;
      overflow-y: scroll;
      box-sizing: border-box;
      padding: 0.3rem;
    }
  }

  .center-box {
    width: 29.3%;

    margin-right: 0.25rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &>div {
      height: 48.7%;
      background: #ffffff;
      border-radius: 0.125rem;
    }
  }

  .right-box {
    // width: 45.5%;
    flex: 1;
    height: 100%;
    background: #ffffff;
    border-radius: 0.125rem;
    display: flex;
    flex-direction: column;
  }

  .right-box-qx {
    width: 76%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .csh-box {
    width: 76%;
    height: 100%;
    background: #ffffff;
    border-radius: 0.125rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .csh-conten {
      .pic {
        position: relative;
        // width: 2.125rem;
        // height: 3.3rem;
        margin-bottom: 0.5rem;

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          font-size: 40px;
          font-family: SFProDisplay;
          font-weight: 400;
          color: #ffffff;
        }
      }

      .txt {
        span {
          cursor: pointer;
          color: rgba(45, 174, 169, 1);
        }
      }

      .btn-box {
        display: flex;
        margin-top: 0.5rem;

        .item {
          cursor: pointer;
          width: 140px;
          height: 36px;
          box-sizing: border-box;
          background: #ffffff;
          border: 1px solid #2daea9;
          border-radius: 4px;
          margin: 0 0.15rem;
          text-align: center;
          line-height: 0.45rem;
          color: rgba(45, 174, 169, 1);
        }

        .item-again {
          background: #2daea9;
          color: white;
        }
      }
    }
  }

  .grayscales {
    -webkit-filter: grayscale(100%);
    /* webkit */
    -moz-filter: grayscale(100%);
    /*firefox*/
    -ms-filter: grayscale(100%);
    /*ie9*/
    -o-filter: grayscale(100%);
    /*opera*/
    filter: grayscale(100%);
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  }

  .right-box-no {
    flex: 1;
    height: 100%;
    background: #ffffff;
    border-radius: 0.125rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
<style lang="scss">
.product-box {
  .el-input__inner {
    height: 0.45rem;
    line-height: 0.45rem;
  }

  .el-input__icon {
    line-height: 0.45rem;
  }

  .el-icon-arrow-up:before {
    content: "\e78f";
  }

  .right-chart {
    margin-top: 0.85rem;
    flex: 1;

    .rb-form {
      padding: 0 0.31rem;

      .form-btns {
        margin-right: 0;
      }
    }

    .chart-lines {
      // width: 11.09rem;
      // height: 4.41rem;
      height: 85%;
      margin: 0.15rem auto 0;
    }

    .form-inputs .el-form-item:not(:last-child) {
      margin-right: 0;
    }

    .form-picker {
      margin-left: 0.125rem;
    }

    .el-form-item {
      margin-right: 0;

      &:first-child {

        // margin-right: 0.44rem;
        .el-select {
          width: 1.79rem;
        }
      }
    }

    .form-picker {
      .picker-div {
        width: 3rem;
      }
    }
  }
}
</style>